import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { isAuthenticated } from '../lib/auth';

const CallToActionSection = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleClick = () => {
    if (isAuthenticated()) {
      navigate('/creer-radio/step1');
    } else {
      localStorage.setItem('fromCreateRadio', 'true');
      navigate('/signup');
    }
  };

  return (
    <section className="px-4 py-16">
      <div className="max-w-5xl mx-auto relative overflow-hidden rounded-3xl bg-gradient-to-r from-purple-600 via-violet-600 to-blue-600 text-white text-center px-6 py-16 shadow-xl">
        <div className="pointer-events-none absolute -top-16 -start-16 w-64 h-64 rounded-full bg-white/10 blur-2xl" />
        <div className="pointer-events-none absolute -bottom-20 -end-10 w-72 h-72 rounded-full bg-fuchsia-400/20 blur-3xl" />
        <div className="relative">
          <h2 className="text-3xl md:text-4xl font-extrabold mb-4">{t('cta.title')}</h2>
          <p className="text-purple-100/90 mb-8 max-w-xl mx-auto">{t('cta.subtitle')}</p>
          <button
            onClick={handleClick}
            className="bg-white text-purple-700 font-semibold px-8 py-3.5 rounded-full hover:-translate-y-0.5 hover:shadow-lg transition"
          >
            {t('cta.button')}
          </button>
        </div>
      </div>
    </section>
  );
};

export default CallToActionSection;
